<template>
  <img class="max-h-72" :src="imageSrc" alt="map" />
</template>

<script setup lang="ts">
type Props = {
  location: {
    lat: number;
    lon: number;
  };
};

const props = defineProps<Props>();

const config = useRuntimeConfig();

const imageSrc = computed(() => {
  return `https://maps.googleapis.com/maps/api/staticmap?key=${config.public.googleApiKey}&size=480x240&scale=2&zoom=15&markers=color:red%7Clabel:Dahl%7C${props.location.lat},${props.location.lon}`;
});
</script>

<script lang="ts">
export default defineComponent({
  name: 'StaticMap',
});
</script>
